var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useRef } from 'react';
import { Autocomplete, Checkbox, Divider, ProgressSteps, Textarea, Text, MapBox, Flex } from '@homeexchange/design';
import i18n from '../../../../i18n';
import AutocompleteService from '../../../../utils/AutocompleteService';
import styles from './addressautocomplete.module.scss';
import Icons from '../../../../utils/Icons';
import IconsNumberOfPath from '../../../../models/IconsNumberOfPath';
import { COORDINATE_PATTERN, parseCoordinates } from '../../../../utils-ts/utils';
import Analytics from '../../../../utils/analytics';
import { HOME_EDIT_DATA_AREA, HOME_FUNNEL_DATA_AREA } from '../../../../utils/utils-ts';
var OVERRIDDEN_ADDRESS_TRUE = 1;
var OVERRIDDEN_ADDRESS_FALSE = 0;
var debounce = function (func, wait) {
    var timeout;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new Promise(function (resolve) {
            clearTimeout(timeout);
            timeout = setTimeout(function () { return resolve(func.apply(void 0, args)); }, wait);
        });
    };
};
var getFormattedResults = function (suggestions) {
    var result = {};
    suggestions.forEach(function (item) {
        result[item.formatedTitle] = item;
    });
    return result;
};
var getSuggestionsFromResults = function (results) {
    return Object.keys(results).map(function (key, index) { return ({ value: key, id: index }); });
};
var getPredictions = debounce(AutocompleteService.getAddressSuggestions, 500);
var validateCoordinate = function (value) { return COORDINATE_PATTERN.test(value); };
var AddressAutocomplete = function (_a) {
    var _b = _a.value, value = _b === void 0 ? '' : _b, onChange = _a.onChange, _c = _a.coordinates, coordinates = _c === void 0 ? '' : _c, _d = _a.textareaError, textareaError = _d === void 0 ? '' : _d, _e = _a.firstAutocompleteError, firstAutocompleteError = _e === void 0 ? '' : _e, _f = _a.secondAutocompleteError, secondAutocompleteError = _f === void 0 ? '' : _f, _g = _a.checked, checked = _g === void 0 ? false : _g, _h = _a.firstAutocompleteLabelHelperContent, firstAutocompleteLabelHelperContent = _h === void 0 ? false : _h, _j = _a.isHomeVerified, isHomeVerified = _j === void 0 ? false : _j, _k = _a.missingLocation, missingLocation = _k === void 0 ? false : _k, _l = _a.isFunnel, isFunnel = _l === void 0 ? false : _l;
    var _m = useState(coordinates
        ? {
            lat: parseFloat(coordinates.split(',')[0]),
            lon: parseFloat(coordinates.split(',')[1])
        }
        : null), markerCoordinates = _m[0], setMarkerCoordinates = _m[1];
    var _o = useState(null), firstPredictions = _o[0], setFirstPredictions = _o[1];
    var _p = useState(null), secondPredictions = _p[0], setSecondPredictions = _p[1];
    var _q = useState(checked), isChecked = _q[0], setIsChecked = _q[1];
    var _r = useState(null), overriddenAddress = _r[0], setOverriddenAddress = _r[1];
    var _s = useState(textareaError), textareaErrorState = _s[0], setTextareaError = _s[1];
    var _t = useState(firstAutocompleteError), firstAutocompleteErrorState = _t[0], setFirstAutocompleteError = _t[1];
    var _u = useState(secondAutocompleteError), secondAutocompleteErrorState = _u[0], setSecondAutocompleteError = _u[1];
    var _v = useState(value), firstAutocompleteValue = _v[0], setFirstAutocompleteValue = _v[1];
    var _w = useState(''), secondAutocompleteValue = _w[0], setSecondAutocompleteValue = _w[1];
    var _x = useState(null), userLocation = _x[0], setUserLocation = _x[1];
    var mapRef = useRef(null);
    var mapUnrecognizedRef = useRef(null);
    useEffect(function () {
        if (textareaError) {
            setTextareaError(textareaError);
        }
    }, [textareaError]);
    useEffect(function () {
        if (firstAutocompleteError) {
            setFirstAutocompleteError(firstAutocompleteError);
        }
    }, [firstAutocompleteError]);
    useEffect(function () {
        if (secondAutocompleteError) {
            setSecondAutocompleteError(secondAutocompleteError);
        }
    }, [secondAutocompleteError]);
    useEffect(function () {
        if (navigator.geolocation && isChecked) {
            navigator.geolocation.getCurrentPosition(function (position) {
                setUserLocation({
                    lat: position.coords.latitude,
                    lon: position.coords.longitude
                });
                setTimeout(function () {
                    var _a;
                    (_a = mapUnrecognizedRef.current) === null || _a === void 0 ? void 0 : _a.jumpTo({
                        center: [position.coords.longitude, position.coords.latitude],
                        zoom: 14
                    });
                }, 500);
            }, function () {
                setUserLocation(null);
            });
        }
    }, [isChecked]);
    var handleCoordinatesSelect = function (selectedValue_1, ref_1) {
        var args_1 = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args_1[_i - 2] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([selectedValue_1, ref_1], args_1, true), void 0, function (selectedValue, ref, moveMap) {
            var parsedCoords, lat, lon, results, firstResult, error_1;
            var _a;
            if (moveMap === void 0) { moveMap = false; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!validateCoordinate(selectedValue)) return [3 /*break*/, 5];
                        parsedCoords = parseCoordinates(selectedValue);
                        lat = parsedCoords.latitude, lon = parsedCoords.longitude;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, AutocompleteService.getGidFromReverseGeocoding({ lat: lat, lon: lon })];
                    case 2:
                        results = _b.sent();
                        firstResult = results[0];
                        if (firstResult === null || firstResult === void 0 ? void 0 : firstResult.geometry) {
                            setMarkerCoordinates({ lat: lat, lon: lon });
                            onChange({
                                location_id: firstResult.properties.gid,
                                address: overriddenAddress,
                                location: {
                                    latitude: lat,
                                    longitude: lon
                                }
                            });
                            if (moveMap) {
                                (_a = ref.current) === null || _a === void 0 ? void 0 : _a.jumpTo({
                                    center: [lon, lat],
                                    zoom: 14
                                });
                            }
                            setSecondAutocompleteError(null);
                        }
                        else {
                            onChange({
                                location_id: null,
                                address: overriddenAddress,
                                location: {
                                    latitude: lat,
                                    longitude: lon
                                }
                            });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        console.error('Error fetching reverse geocoding data:', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        handleAddressSelect(selectedValue, 19, ref);
                        _b.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    var handleAddressSelect = function (selectedValue, zoom, ref) { return __awaiter(void 0, void 0, void 0, function () {
        var results, firstResult, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, AutocompleteService.getAddressSuggestions(selectedValue)];
                case 1:
                    results = _b.sent();
                    firstResult = results[0];
                    if (firstResult === null || firstResult === void 0 ? void 0 : firstResult.geometry) {
                        setMarkerCoordinates({
                            lat: firstResult.geometry.coordinates[1],
                            lon: firstResult.geometry.coordinates[0]
                        });
                        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.jumpTo({
                            center: [firstResult.geometry.coordinates[0], firstResult.geometry.coordinates[1]],
                            zoom: zoom
                        });
                        onChange({
                            address: isChecked ? overriddenAddress : firstResult.formatedTitle,
                            location_id: firstResult.properties.gid,
                            location: {
                                latitude: firstResult.geometry.coordinates[1],
                                longitude: firstResult.geometry.coordinates[0]
                            }
                        });
                        if (isChecked) {
                            setSecondAutocompleteError(null);
                        }
                        else {
                            setFirstAutocompleteError(null);
                        }
                    }
                    else {
                        if (isChecked) {
                            setSecondAutocompleteError(i18n.t('home:enter_address_or_gps'));
                        }
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _b.sent();
                    console.error('Error fetching address suggestions:', error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onFirstInputChange = function (value) {
        setFirstAutocompleteValue(value);
        if (value !== '') {
            getPredictions(value)
                .then(function (predictions) {
                setFirstPredictions(getFormattedResults(predictions));
            })
                .catch(function (error) {
                console.error('Error fetching predictions:', error);
            });
        }
        else if (value === '') {
            setFirstPredictions(null);
            onChange({ address: value });
        }
    };
    var onSecondInputChange = function (value) {
        var _a;
        setSecondAutocompleteValue(value);
        setSecondAutocompleteError(null);
        if (validateCoordinate(value)) {
            var _b = value.split(',').map(Number), lat = _b[0], lon = _b[1];
            setSecondPredictions((_a = {},
                _a[value] = {
                    formatedTitle: value,
                    bbox: '',
                    properties: { layer: '', value: '', gid: '' },
                    geometry: { coordinates: [lat, lon] }
                },
                _a));
        }
        else if (value !== '') {
            getPredictions(value)
                .then(function (predictions) {
                setSecondPredictions(getFormattedResults(predictions));
            })
                .catch(function (error) {
                console.error('Error fetching predictions:', error);
            });
        }
        else if (value === '') {
            setSecondPredictions(null);
            setSecondAutocompleteError(i18n.t('home:enter_address_or_gps'));
            onChange({ location_id: value });
        }
    };
    var onCheckboxChangeHandler = function () {
        var newCheckedState = !isChecked;
        setIsChecked(newCheckedState);
        var overriddenAddress = newCheckedState ? OVERRIDDEN_ADDRESS_TRUE : OVERRIDDEN_ADDRESS_FALSE;
        onChange({ overridden_address: overriddenAddress, location: {}, address: '' });
        setTextareaError(null);
        setSecondAutocompleteError(null);
        setFirstAutocompleteError(null);
        setSecondAutocompleteValue('');
        setFirstAutocompleteValue('');
        setMarkerCoordinates(null);
        Analytics.trackGTM('address_unrecognized', {
            event_data: {
                action: 'click',
                text: 'confirm_location_address_recognized',
                area: isFunnel ? HOME_FUNNEL_DATA_AREA : HOME_EDIT_DATA_AREA,
                value: newCheckedState ? 'true' : 'false'
            }
        });
    };
    var onTextareaChangeHandler = function (e) {
        var newValue = e.target.value;
        setOverriddenAddress(newValue);
        setTextareaError(null);
        onChange({ address: newValue });
    };
    return (React.createElement("div", { className: styles['container'] },
        React.createElement(Autocomplete, __assign({ key: "first-autocomplete-".concat(isChecked ? 'checked' : 'unchecked'), label: i18n.t('search:home_address'), inputValue: isChecked ? '' : firstAutocompleteValue, suggestions: getSuggestionsFromResults(firstPredictions || {}) }, (firstAutocompleteLabelHelperContent && {
            labelHelperContent: String(i18n.t('home:home_address_info'))
        }), { onChange: onFirstInputChange, onSelect: function (value) { return handleAddressSelect(value, 12, mapRef); }, noSuggestionText: i18n.t('common:no_result'), disabled: isChecked || (isHomeVerified && !missingLocation), hasError: !!firstAutocompleteErrorState && !isChecked, errorText: firstAutocompleteErrorState && !isChecked ? firstAutocompleteErrorState : '', inputIcon: "search-location-pin", itemsIcon: "search-location-pin" })),
        isHomeVerified && !missingLocation ? (React.createElement("div", { className: styles['home-verified-container'] },
            React.createElement("span", { className: "icon-selection-tick-selected" }, Icons.transform(IconsNumberOfPath.SELECTION_TICK_SELECTED)),
            React.createElement("p", { className: styles['verified-address-status'] }, String(i18n.t('home:verified_address_status'))))) : (React.createElement("div", { className: styles['checkbox-container'] },
            React.createElement(Checkbox, { label: i18n.t('search:home_address_is_not_on_the_list'), value: "addressNotListed", onChange: onCheckboxChangeHandler, checked: isChecked }))),
        isChecked && (React.createElement(React.Fragment, null,
            React.createElement(Divider, { space: "medium" }),
            React.createElement(Flex, { isFullWidth: true, gap: "8" },
                React.createElement(Text, { isBold: true, size: "xl" }, "Let's do this manually!"),
                React.createElement(ProgressSteps, { orientation: "vertical", steps: [
                        {
                            content: (React.createElement(Textarea, { id: "unrecognised-textarea", title: i18n.t('home:home.unrecognizedAddress.enterAddress.label'), helperText: i18n.t('search:enter_address_for_guests'), onChange: onTextareaChangeHandler, value: overriddenAddress || '', status: textareaErrorState ? 'error' : 'default', message: textareaErrorState || '' }))
                        },
                        {
                            content: (React.createElement(Flex, { gap: "8", className: styles['autocomplete-coordinates'], isFullWidth: true },
                                React.createElement("div", null,
                                    React.createElement(Text, { isBold: true }, i18n.t('home:home.unrecognizedAddress.pinHome.label')),
                                    React.createElement(Text, { size: "sm", className: styles['map-helper-text'] }, i18n.t('home:home.unrecognizedAddress.pinHome.helper'))),
                                React.createElement(Autocomplete, { key: "second-autocomplete-".concat(isChecked ? 'checked' : 'unchecked'), label: i18n.t('home:home.unrecognizedAddress.gpsCoordinates.label'), inputValue: secondAutocompleteValue || '', labelHelperContent: React.createElement("span", { dangerouslySetInnerHTML: {
                                            __html: i18n.t('home:home.unrecognizedAddress.gpsCoordinates.helper')
                                        } }), suggestions: getSuggestionsFromResults(secondPredictions || {}), onChange: onSecondInputChange, onSelect: function (value) {
                                        return handleCoordinatesSelect(value, mapUnrecognizedRef, true);
                                    }, noSuggestionText: i18n.t('common:no_result'), hasError: !!secondAutocompleteErrorState, errorText: secondAutocompleteErrorState || '', inputIcon: "search-location-pin", itemsIcon: "search-location-pin" }),
                                React.createElement(Flex, { direction: "column", gap: "2", isFullWidth: true },
                                    React.createElement("div", null,
                                        React.createElement(Text, { isBold: true }, i18n.t('home:home.unrecognizedAddress.movePin.label')),
                                        React.createElement(Text, { size: "sm", className: styles['map-helper-text'] }, i18n.t('home:home.unrecognizedAddress.movePin.helper'))),
                                    React.createElement(MapBox, { ref: mapUnrecognizedRef, mapStyle: "https://api.jawg.io/styles/jawg-sunny.json?access-token=ISSuiu5R48VFKdltBfogTgBSdaH68izqpiQ9C0WkBXS2Jg1lQSp02Hy5vVPCTgfT&lang=en", bounds: [-120, -50, 80, 60], onMoveEnd: function (event) {
                                            var _a = event.viewState, latitude = _a.latitude, longitude = _a.longitude;
                                            setSecondAutocompleteValue("".concat(latitude, ", ").concat(longitude));
                                            handleCoordinatesSelect("".concat(latitude, ", ").concat(longitude), mapUnrecognizedRef);
                                        }, centerMarker: {
                                            content: (React.createElement("img", { src: "https://d2kzpkef14nfxb.cloudfront.net/images/website/search/verified_home.svg" })),
                                            offset: {
                                                y: -25
                                            }
                                        }, positionNavControl: "bottom-left", padding: { top: 20, bottom: 20, right: 20, left: 20 } }))))
                        }
                    ] })))),
        markerCoordinates && !isChecked && (React.createElement("div", { className: styles['map-container'] },
            React.createElement(MapBox, { ref: mapRef, mapStyle: "https://api.jawg.io/styles/jawg-sunny.json?access-token=ISSuiu5R48VFKdltBfogTgBSdaH68izqpiQ9C0WkBXS2Jg1lQSp02Hy5vVPCTgfT&lang=en", initialViewState: {
                    longitude: markerCoordinates.lon,
                    latitude: markerCoordinates.lat,
                    zoom: 12
                }, singleMarker: {
                    longitude: markerCoordinates.lon,
                    latitude: markerCoordinates.lat,
                    content: (React.createElement("img", { src: "https://d2kzpkef14nfxb.cloudfront.net/images/website/search/verified_home.svg" }))
                }, circleLayer: {
                    longitude: markerCoordinates.lon,
                    latitude: markerCoordinates.lat,
                    radiusInMeters: 1000,
                    color: 'secondary'
                }, positionNavControl: "bottom-left", popup: {
                    latitude: markerCoordinates.lat,
                    longitude: markerCoordinates.lon,
                    content: i18n.t('search:location_radius_1km'),
                    offset: [0, -25]
                } })))));
};
export default AddressAutocomplete;
